import { List, ListItem, makeStyles, Typography } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { Collapse } from '@material-ui/core';
import LogoEnd from 'components/Icons/Menu/LogoEnd';
import LogoMain from 'components/Icons/Menu/LogoMain';
import OpenCloseMenuIcon from 'components/Icons/Menu/OpenCloseMenuIcon';
import { EtemMenuItem } from '.';
import { STATE_MENU_STYLES } from './Menu.style';
import NavLink from './NavLink';
import { MenuContext } from '../../menuContext';
import DropDownIcon from '../Icons/Menu/DropDownIcon';

const useStyles = makeStyles({
  ...STATE_MENU_STYLES,
});

const Menu = ({ menuItems }: { menuItems: Array<Array<EtemMenuItem>> }) => {
  const { open: isOpen, setOpen: setIsOpen, submenuIsOpen, setSubmenuIsOpen } = useContext(MenuContext);
  const classes = useStyles();
  const [isOpenDropDown, setIsOpenDropDown] = useState(false);
  const [isMenuCloseByUser, setIsMenuCloseByUser] = useState(false);
  const [currentSubmenu, setCurrentSubmenu] = useState<{ title: any; icon: any; menu?: Array<EtemMenuItem> } | null>(
    null,
  );
  const [activeSubMenu, setActiveSubMenu] = useState<string>('');

  const handleClick = (title: any, icon: any, menu?: Array<EtemMenuItem>) => {
    if (!menu) {
      setCurrentSubmenu(null);
      setSubmenuIsOpen(false);
      setIsOpenDropDown(false);
      if (!isMenuCloseByUser) {
        setIsOpen(true);
      }
      return;
    }

    const newSubmenu = { title, icon, menu };
    setCurrentSubmenu(newSubmenu);
    setIsOpen(false);

    setSubmenuIsOpen(true);
  };

  const handleClickOpenOrClose = () => {
    setIsMenuCloseByUser(!isMenuCloseByUser);

    if (submenuIsOpen) {
      setSubmenuIsOpen(false);
      setIsOpen(false);
      return;
    }
    setIsOpen(!isOpen);
  };

  const handleClickDropDown = (to?: string, dropdown?: Array<EtemMenuItem>) => {
    if (dropdown && to) {
      if (activeSubMenu === to) {
        setActiveSubMenu('');
        setIsOpenDropDown(false);
      } else {
        setActiveSubMenu(to);
        setIsOpenDropDown(true);
      }
    }
  };

  return (
    <div className={classnames({ [classes.isOpen]: isOpen }, classes.menu)}>
      <OpenCloseMenuIcon
        data-qa-id="open-close-button"
        onClick={handleClickOpenOrClose}
        className={classnames({ [classes.openCloseIconisOpen]: !isOpen && submenuIsOpen }, classes.openCloseIcon)}
      />

      <div className={classnames(classes.mainMenu)}>
        <Link className={classes.logo} to="/">
          <LogoMain />
          <LogoEnd className={classes.logoEnd} />
        </Link>

        {menuItems?.map((c, i) => (
          <List className={classes.category} key={i}>
            {c
              ?.filter((m: EtemMenuItem) => m.canAccess)
              ?.map((item: EtemMenuItem, i) => (
                <ListItem className={classes.listItem} key={i}>
                  <NavLink
                    to={item?.to}
                    tooltip={!isOpen ? item.text : ''}
                    className={classes.navLink}
                    activeClassName={classes.activeLink}
                    exact={item.exact}
                    urlMatch={item?.urlMatch}
                    isWithSubmenu={item?.submenu !== undefined}
                    isActiveSubmenu={currentSubmenu?.title === item.text}
                    onClick={() => handleClick(item.text, item.icon, item?.submenu)}
                  >
                    {item.icon}
                    <span className={classes.navLinkText}>{item.text}</span>
                  </NavLink>
                </ListItem>
              ))}
          </List>
        ))}
      </div>

      <div className={classnames({ [classes.submenuIsOpen]: submenuIsOpen }, classes.submenu)}>
        <Typography className={classes.submenuTitle} variant="h3">
          <span className={classes.submenuTitleIcon}>{currentSubmenu?.icon}</span>
          <span className={classes.submenuTitleText}>{currentSubmenu?.title}</span>
        </Typography>

        {currentSubmenu?.menu
          ?.filter(m => m.canAccess)
          .map((item: EtemMenuItem, i) => (
            <ListItem className={classes.listItem + (item?.dropdown ? ' ' + classes.blockDisplay : '')} key={i}>
              <NavLink
                to={item.to}
                className={classes.submenuLink}
                activeClassName={classes.activeLink}
                exact={item.exact}
                urlMatch={item?.urlMatch}
                onClick={() => handleClickDropDown(item.to, item?.dropdown)}
                data-qa-id={`submenuLink-to-${item?.to?.substring(1)}`}
                isWithSubmenu={item?.dropdown !== undefined}
              >
                {item.icon}
                <span>{item.text}</span>
                {item?.dropdown !== undefined && (
                  <span style={{ paddingLeft: '12px' }}>
                    <DropDownIcon />
                  </span>
                )}
              </NavLink>
              {item?.dropdown && (
                <Collapse in={isOpenDropDown && activeSubMenu === item.to} timeout="auto" unmountOnExit>
                  {item?.dropdown?.map((d, index) => (
                    <ListItem component="ul" className={classes.listItem} key={`dropdown-${i}-${index}`}>
                      <NavLink
                        to={d.to}
                        className={classes.submenuLink}
                        activeClassName={classes.activeLink}
                        exact={d.exact}
                        urlMatch={d?.urlMatch}
                        data-qa-id={`dropdownLink-to-${d?.to?.substring(1)}`}
                      >
                        {d.icon}
                        <span>{d.text}</span>
                      </NavLink>
                    </ListItem>
                  ))}
                </Collapse>
              )}
            </ListItem>
          ))}
      </div>
    </div>
  );
};

export default Menu;
